import React, { Component } from 'react';
import { NavBar, Icon, WhiteSpace, WingBlank, Flex } from 'antd-mobile';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/AgentMore.css';
import iconDevice from '../medias/device.svg';
import iconPacket from '../medias/packet.svg';
import iconSite from '../medias/site.svg';
import iconTeam from '../medias/team.svg';
import iconCoupon from '../medias/coupon.svg';
import iconIssuer from '../medias/issuer.svg';
import iconGame from '../medias/game.svg';

const history = require("history").createHashHistory()

class AgentMore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            agentProfile: {}
        };
    }

    componentDidMount() {
        this.loadProfile()
    }

    loadProfile = () => {
        DataFetcher.agentProfile({
            success: (resp) => {
                this.setState({
                    agentProfile: resp.data
                })
            }
        })
    }

    render() {
        const { agentProfile } = this.state
        let menuItems = [
            {name: '设备管理', path: '/device', icon: iconDevice},
            {name: '套餐设置', path: '/packet', icon: iconPacket},
            {name: '门店管理', path: '/site', icon: iconSite, width: 35}
        ];
        menuItems.push({name: '优惠活动', path: '/agent/coupon', icon: iconCoupon})
        menuItems.push({name: '发券商', path: '/agent/coupon_organization', icon: iconIssuer})
        if(agentProfile.agentLevel === 1) {
            menuItems.push({name: '我的团队', path: '/team', icon: iconTeam})
        }
        menuItems.push({name: '游戏管理', path: '/agent/game', icon: iconGame})
        
        // eslint-disable-next-line
        let groupCount = parseInt(menuItems.length/4) + (menuItems.length % 4 > 0 ? 1 : 0)
        let menuGroups = []
        for(let i = 0; i < groupCount; i++) {
            let menuGroup = []
            for(let j = 0; j < 4; j++) {
                let index = i * 4 + j;
                if(index >= menuItems.length) {
                    menuGroup.push({})
                } else {
                    menuGroup.push(menuItems[index])
                }
            }
            menuGroups.push(menuGroup)
        }

        return (
            <div className='page-agent-more'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                >
                    更多功能
                </NavBar>
                <WingBlank size="md" style={{paddingTop: 50}}>
                    <WhiteSpace/>
                    {menuGroups.map((group, groupIndex) => {
                        return (
                            <Flex className='wrapper-menu' key={groupIndex}>
                                {group.map((menu, menuIndex) => {
                                    if(menu.name) {
                                        return (
                                            <Flex.Item key={menuIndex} onClick={() => {history.push(menu.path)}}>
                                                <img src={menu.icon} alt={menu.name} style={menu.width?{width: menu.width}:{}}/>
                                                <div className='name'>{menu.name}</div>
                                            </Flex.Item>
                                        )
                                    } else {
                                        return (
                                            <Flex.Item key={menuIndex}>
                                            </Flex.Item>
                                        )
                                    }
                                })}
                            </Flex>
                        )
                    })}
                </WingBlank>
            </div>
        )
    }
}

export default createForm()(AgentMore);


// WEBPACK FOOTER //
// ./src/modules/AgentMore.js